import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import {
  LookupManagementService,
  TypeDisplayInfo,
  vsServiceName as LookupManagementServiceName,
} from "./service";

export class LookupManagementComponentController implements IOnInit {
  static $inject = [LookupManagementServiceName, "$state"];

  private displayInfo!: TypeDisplayInfo[];
  selectedType: TypeDisplayInfo | undefined;
  private readonly initialType: string | undefined;

  constructor(
    private readonly lookupManagementService: LookupManagementService,
    private readonly $state: StateService
  ) {}

  $onInit(): void {
    this.displayInfo = this.lookupManagementService.getConfigs();
    if (this.initialType) {
      const lookupInfo = this.displayInfo.find(
        (i) => i.name === this.initialType
      );
      if (lookupInfo === undefined) {
        throw new Error("Couldn't find selected lookup type");
      }
      this.selectedType = lookupInfo;
    }
  }

  typeSelected(type: { name: string; displayName: string }) {
    this.$state.go(
      ".detail.grid",
      { type: type.name },
      { reload: ".", relative: "main.machines.lookups" }
    );
  }
}
